module.exports = __webpack_public_path__ + "static/WSCC-85de056baefe95970a4f2a1ae7318402.png";